module.exports = __webpack_public_path__ + "static/img/4-role.5d85dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/4-role.png
// module id = P8Dt
// module chunks = 1